<template>
  <div v-loading="$wait.waiting(_uid)" class="card">
    <div class="card-content">
      <div class="text-right control-button-wrapper pt-xxs">
        <acl :roles="canNewEvent()">
          <router-link :to="{ name: 'my_events@create' }">
            <button
              class="btn btn-info btn-fill btn-wd submit-button"
              :class="{ loading: $wait.waiting(_uid) }"
            >
              New
              <i
                v-show="$wait.waiting(_uid)"
                class="fas fa-circle-notch loading-icon"
              />
            </button>
          </router-link>
        </acl>
      </div>

        <el-tabs :value="activeTab" @tab-click="selectTab">
          <el-tab-pane label="All" name="all">
            <div v-if="matchTab('all')">
              <EventTable :data="activeList" @eventShow="handleShow" />
            </div>
          </el-tab-pane>

          <el-tab-pane label="Archived" name="archived">
            <div v-if="matchTab('archived')">
              <EventTable :data="archivedList" @eventShow="handleShow" />
            </div>
          </el-tab-pane>
        </el-tabs>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Loading } from "element-ui";
import { mapGetters, mapActions } from "vuex";
import MyService from "@app/services/my";
import EventTable from "@components/Events/Components/Table.vue";
import rolesConstants from "@/components/acl/roles";
import { getStorageData } from "@/utils/storage";
import parseSettings from "@providers/parseSettings";

Vue.use(Loading.directive);

export default {
  components: {
    EventTable,
  },
  data() {
    return {
      activeTab: "all",
      activeList: [],
      archivedList: [],
      list: [],
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    routeParams() {
      return this.$route.params;
    },
    routeQuery() {
      return this.$route.query;
    },
  },
  created() {
    this.ROLE_SUPER = rolesConstants.ROLE_SUPER;
    this.ROLE_ADMIN = rolesConstants.ROLE_ADMIN;
    this.ROLE_COMPANY_MANAGER = rolesConstants.ROLE_COMPANY_MANAGER;
    this.ROLE_TRAINING_MANAGER = rolesConstants.ROLE_TRAINING_MANAGER;
    this.ROLE_TRAINEE = rolesConstants.ROLE_TRAINEE;
    this.ROLE_SUPPORT = rolesConstants.ROLE_SUPPORT;
    this.ROLE_CTOPS = rolesConstants.ROLE_CTOPS;
  },
  mounted() {
    this.getList();
    return;
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
    parseSettings,
    selectTab({ paneName }) {
      if (!paneName) {
        return (this.activeTab = "all");
      }
      this.activeTab = paneName;
    },
    matchTab(pane) {
      return this.activeTab === pane;
    },
    async getList() {
      try {
        this.$wait.start(this._uid);
        const list = await MyService.getEvents();

        this.activeList = list.filter(function (events) {
          return events.is_active;
        });

        this.archivedList = list.filter(function (events) {
          return !events.is_active;
        });
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
      return;
    },
    canNewEvent() {
      const roleList = [];

      roleList.push(this.ROLE_COMPANY_MANAGER);
      roleList.push(this.ROLE_TRAINING_MANAGER);

      const company = getStorageData("company");
      const companySettings = this.parseSettings(company.settings);
      
      if (companySettings.events_documents) {
        roleList.push(this.ROLE_TRAINEE);
        return roleList;
      }

      return roleList;
    },
    handleShow(event) {
      return this.$router.push({
        name: "my_events@show",
        params: { id: event.id },
      });
    },
  },
};
</script>

<style></style>
